import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, InputSignal, OnChanges, Output, Signal } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { ProductLinkDirective, ProductPriceVisibilityService } from '@libs/shared/ui';
import { AddToCartModel, ProductModel } from '@libs/shop/models';
import { ConfigurableBundleCatalogCardComponent } from '../../configurable-bundles/configurable-bundle-catalog-card/configurable-bundle-catalog-card.component';
import { AddToCartComponent, AddToCartFormResult } from '../../elements/add-to-cart';
import { ProductCardCoreComponent } from '../product-card-core';
import { ProductPricesComponent } from '../product-prices';

@Component({
  selector: 'ui-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductPricesComponent,
    AddToCartComponent,
    ProductCardCoreComponent,
    MatAnchor,
    ProductLinkDirective,
    ConfigurableBundleCatalogCardComponent,
  ],
})
export class ProductCardComponent implements OnChanges {
  @Output() public addToShoppingListClicked: EventEmitter<AddToCartModel<ProductModel>> = new EventEmitter<AddToCartModel<ProductModel>>();

  public showActions: InputSignal<boolean> = input(false);
  public isPromotion: InputSignal<boolean> = input(false);
  public product: InputSignal<ProductModel> = input.required();
  public displayListView: InputSignal<boolean> = input(false);
  public position: InputSignal<number> = input.required();

  public productPriceIsVisible: Signal<boolean> = computed(() => this.priceVisibilityService.arePricesVisible(this.product().prices));
  public productHasPrice: Signal<boolean> = computed(() => !!this.product().prices);

  public wrapperClass: Signal<string> = computed(() => 'wrapper-content-' + (this.displayListView() ? 'list' : 'grid'));

  public actionType: Signal<ProductModel['actionType'] | undefined> = computed(() => {
    if (!this.showActions()) {
      return;
    }

    return this.product().actionType ?? 'add-to-cart';
  });

  public formattedUVP: string = '';

  public constructor(private readonly priceVisibilityService: ProductPriceVisibilityService) {
  }

  public ngOnChanges(): void {
    const endUserPrice: number | undefined = this.product()?.prices?.endUser;

    if (endUserPrice === undefined || endUserPrice === null) {
      this.formattedUVP = '';
    } else {
      this.formattedUVP = (endUserPrice / 1000).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }

  public onAddToShoppingList(event: AddToCartFormResult): void {
    this.addToShoppingListClicked.emit({ quantity: event.productQuantity, item: this.product() });
  }
}
